import { ERROR_PATH, NOT_AUTHORIZED_PATH } from '../../../../utils/constants/local-paths';
import { type LocalPaths } from '../../../../utils/data/get-local-paths';

type UseIsHeaderSecondaryThemeProps = {
  pathname: string;
  paths: LocalPaths;
};

export const isHeaderSecondaryTheme = ({ pathname, paths }: UseIsHeaderSecondaryThemeProps) => {
  const primaryHeaderThemePaths = [
    paths.learnPagePath,
    paths.accountSettingsPagePath,
    paths.searchPagePath,
    paths.adminDashboardPagePath,
    paths.quizPagePath,
    paths.memberDirectoryPath,
    ERROR_PATH,
    NOT_AUTHORIZED_PATH,
  ];

  // this is needed for nested paths for example /member-directory & /member-directory/profile
  const secondaryHeaderThemePaths = [paths.memberDirectoryProfilePath];

  const isSecondaryTheme =
    secondaryHeaderThemePaths.some((path) => pathname.startsWith(path)) ||
    !primaryHeaderThemePaths.some((path) => pathname.startsWith(path));

  return isSecondaryTheme;
};
